import { useAuthorStore } from "@/stores/models/resourceCenter";

export default async function authorExists({ to }) {
    let exists = false;
    let cId = to.params.authorId;
    if (cId) {
        try {
            const authorStore = useAuthorStore();
            let existing = authorStore.item(cId);

            if (!existing) {
                await authorStore.fetchItem({
                    key: "VIEW_AUTHOR",
                    query: { id: cId }
                });
            }

            exists = true;
        } catch (err) {
            exists = false;
        }
    }

    if (!exists) {
        return {
            name: "Not Found"
        };
    }
}
